import { render, staticRenderFns } from "./CapitationReports.vue?vue&type=template&id=27f07382&"
import script from "./CapitationReports.vue?vue&type=script&lang=js&"
export * from "./CapitationReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports